/**
 * Page Header
 */
export class Header {

	#element;

	/**
	 * Constructor
	 */
	constructor() {

		this.#element = document.querySelector( ".page-header" );
		this.init();

	}

	/**
	 * Initialize the header
	 */
	init() {

		window.addEventListener( "scroll", this.#handleScrollPage.bind( this ) );

	}

	/**
	 * Handles the scroll event on the page and toggles the 'page-header--fixed' class on the header element when the page is scrolled down.
	 *
	 * @return {void}
	 */
	#handleScrollPage() {

		if ( window.scrollY > this.#element.scrollHeight ) {

			this.#element.classList.add( "page-header--fixed" );

		} else {

			this.#element.classList.remove( "page-header--fixed" );

		}

	}

}
